module.exports = __webpack_public_path__ + "assets/images/invisible-asia/3-singapore.jpg?v=a96eaba3";